/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({"data":{"yue":{"categories":{"cardinal":["other"],"ordinal":["other"]},"fn":function(n, ord) {
  return 'other';
}}},"aliases":{"yue-CN":"yue-Hans-CN","yue-HK":"yue-Hant-HK"},"parentLocales":{},"availableLocales":["yue"]})
}
